<section class="page-hero footer-sections">
    <!--//End Header-->
    <div class="container">
        <h3 class="terms_title">VISOR HEALTH – PRIVACY POLICY </h3>
        <h6>Effective Date: June 1, 2026</h6>

        <div class="terms_content">
            <div class="block">
                <p>Note: This privacy policy applies to our collection, use, and disclosure of data received or created
                    due to your access to and use of certain items provided by us, “Visor Health, Inc.” (referred to
                    here as “Visor,” “we,” “us,” or “our”). These items consist of our web-based and mobile
                    applications, including but not limited to CarePilot and PT Copilot (collectively the
                    “Application”).
                </p>
                <p>WE MAY USE COOKIES, PIXELS, AND OTHER TRACKING TECHNOLOGIES, INCLUDING THIRD-PARTY TRACKING
                    TECHNOLOGIES, OR (COLLECTIVELY, “TRACKING TECHNOLOGIES”) ON OUR APPLICATION. WE USE TRACKING
                    TECHNOLOGIES TO COLLECT DATA AND PERFORM DATA ANALYTICS, TO RECORD HOW YOU INTERACT WITH THE SITE
                    AND OUR CONTENT, THE INFORMATION YOU TYPE, AND OTHER USER-RELATED ACTIVITIES. </p>
                <p>BY VISITING AND USING THE APPLICATION, YOU ARE CONSENTING TO OUR USE OF TRACKING TECHNOLOGIES AND YOU
                    UNDERSTAND AND AGREE THAT WE MAY SHARE PERSONAL INFORMATION ABOUT YOU THAT WE COLLECT FROM THE USE
                    OF TRACKING TECHNOLOGIES WITH THE THIRD-PARTIES THAT SUPPORT THOSE TRACKING TECHNOLOGIES. FOR MORE
                    INFORMATION ABOUT HOW WE USE TRACKING TECHNOLOGIES, PLEASE SEE THE INFORMATION BELOW. </p>

            </div>
            <div class="block">
                <strong>
                    <h5>Your Consent </h5>
                </strong>
                <p>By accessing or using the Application, you are consenting to our processing of the information
                    described in this Privacy Policy. “Processing,” means using cookies on a computer or mobile device
                    or using or touching information in any way, including, but not limited to, collecting, storing,
                    deleting, using, combining, and disclosing information. Information processed by the Application
                    will be transferred, processed, and stored in accordance with United States state and federal law.
                </p>

            </div>
            <div class="block">
                <strong>
                    <h5>What information is collected by the Application and how is it used? </h5>
                </strong>
                <ol type="A">
                    <li>User Information.
                        <p>We collect personal information (such as your name, mailing address, email address and phone
                            number) from you when you download and log into the Application and/or submit information to
                            us through the Site (“User Information”). We keep User Information to provide you with the
                            Application. For us to provide you with the Application, it is required that we collect the
                            User Information. </p>
                        <ol type="i">
                            <li><u>Examples of User Information we Collect:</u> Your name, alias, unique personal device
                                identifier, email address, and mailing address, if you provide that information to us
                                through our “Contact Us” form, user sign-up workflow, or another pathway. </li>
                            <li><u>How Long we Retain User Information:</u> We store this information as you continue to
                                use
                                the Application; while we keep a business relationship with you; and as required for any
                                other business or legal purpose.</li>
                        </ol>
                        <p>We may use User Information that we collect from you to contact you or send you information,
                            for example, to send you our newsletters, marketing or promotional materials, and other
                            information that we think may be of interest to you. You may opt out of receiving any, or
                            all, of these communications from us by following the unsubscribe link or the instructions
                            provided in any email we send.

                        </p>
                    </li>
                    <li>Application Information.
                        <p>We collect your personal health and wellness information, inputs from user surveys and data
                            created through your interaction with the Application (“Application Information”).
                            Application Information may include clinical information (such as height and weight, current
                            disease information, symptom history and other medical data related to your health) and
                            non-clinical lifestyle information (such as eating habits and exercise activity). </p>
                        <p>
                            Certain Application Information that we collect or created through your use of the
                            Application may also be the “Protected Health Information” (“PHI”) of the health care
                            provider who enrolled you to use the Application. PHI is regulated at the federal level by
                            the Health Insurance Portability and Accountability Act of 1996 (“HIPAA”). Notwithstanding
                            anything to the contrary elsewhere in this Privacy Policy applying more generally to the
                            information that we collect from you, to the extent the information that we provide to a
                            health care provider about you, or that a health care provider provides to us about you,
                            constitutes PHI, we will protect your PHI and will only use or disclose it as required or
                            permitted by applicable federal and state laws, including HIPAA, and in accordance with any
                            contractual obligations that we may have with your health care provider. It may be necessary
                            for us to share your PHI with third parties, including suppliers that we engage to provide
                            services in connection with the Service. If we share your PHI with any third party, we will
                            share only the minimum necessary information to enable the third party to provide the
                            services for which we have engaged them in connection with the Service, and we will ensure
                            that the third party agrees to use and disclose your PHI only as required or permitted by
                            applicable federal and state laws, including HIPAA.
                        </p>
                        <p>
                            Visor Health is not itself a health care provider, and so, to the extent that we are
                            collecting Application Information about you for our own purposes, that information is being
                            collected with your consent through this Privacy Policy, and used by us for the purposes
                            described in this Privacy Policy. Because Application Information may be related to your
                            health, certain other state laws, such as the Washington State My Health My Data Act
                            (“MHMDA”), and the Nevada Health Data Privacy Act (“NHDPA”). These laws require us to
                            provide a separate policy specific to our collection and use of your “Consumer Health Data”.
                            You may access that policy [[here]].
                        </p>
                        <p>
                            We will only use this Application Information in an identifiable form as it relates to
                            providing you with the Application and its related functionality, though you do agree that
                            we may de-identify Application Information in accordance with applicable law. Once
                            de-identified, such data will no longer be considered Application Information, and we may
                            then make use of it for any lawful purpose.
                        </p>
                        <ol type="i">
                            <li>
                                <u>Examples of Application Information we Collect:</u> Information that you input while
                                using the Application, such as diagnostic questionnaires and surveys and scheduling
                                information.
                            </li>
                            <li><u>How Long we Retain Application Information:</u> We store this information as you
                                continue to
                                use the Application; while we keep a business relationship with you; and as required for
                                any other business or legal purpose. When you stop using the Application, we will
                                promptly delete Application Information, provided however that you understand
                                Application Information shared with your health care provider may not be deleted by
                                them. Additionally, and Application Information that we have de-identified will not be
                                deleted, because it can no longer be identified to you or your use of the Application
                            </li>
                        </ol>
                    </li>
                    <li>Usage Data. 
                        <p>
                            In addition, the Application may collect or generate certain information automatically, such
                            as “metadata” about your navigation through the Application, the type of mobile device you
                            use, your mobile device’s unique device ID, the IP address of your mobile device, your
                            mobile operating system, the type of mobile Internet browsers you use, and information about
                            your use of the Application (“Usage Data”). Usage Data will be used by us either
                            individually or in aggregated form to enhance and improve the Application, and we retain
                            Usage Data indefinitely.
                        </p>
                    </li>
                </ol>
            </div>
            <div class="block">
                <strong>
                    <h5>Do third parties see and/or have access to information obtained by the Application? </h5>
                </strong>
                <p>User Information, Application Information and Usage Data may be shared with the third-party service
                    providers who host and support the Application on our behalf. These service providers do not have
                    any right to independently use any personal information that we share with them. </p>
                <p>When you register to use the Application, you are also asked to review and submit a HIPAA
                    Authorization Form that allows us to share Application Information with the health care provider
                    that enabled your use of the Application. </p>
            </div>

            <div class="block">
                <strong>
                    <h5>What are my opt-out rights? </h5>
                </strong>
                <p>We only collect the User Information, Usage Data, and Application Information that is necessary to
                    provide you with the Application. Because of this, the only way to opt out of information collection
                    is by stopping your use of and uninstalling the Application. </p>
                <p>
                    Because the Application is a tool that your provider is using to provide you with care, the HIPAA
                    Authorization we collect from you when you register to use the Application is required for us to
                    provide the Application. If you no longer wish your provider to have access to your data, you may
                    contact us to withdraw your HIPAA Authorization. However, understand that doing so will require us
                    to discontinue your access to the Application, and that we will also notify your provider to ensure
                    that they can continue to effectively provide you with care outside of the Application.
                </p>
                <p>
                    If you do not wish to receive marketing emails from us, you can opt out of future marketing emails
                    by following the instructions provided in the marketing emails. Opting out of marketing emails will
                    not affect our administrative emails to you (e.g., emails about your transactions or policy
                    changes).
                </p>
            </div>

            <div class="block">
                <strong>
                    <h5>What Tracking Technologies do we use on the Application? </h5>
                </strong>
                <ol type="A">
                    <li>
                        Cookies and pixels.
                        <p>
                            Cookies are pieces of information stored directly on your device. Pixels are tracking
                            technologies embedded in the Application. Cookies and Pixels allow us to collect information
                            such as browser type, time spent using the Application, pages visited, language preferences,
                            and other anonymous traffic and analytics data. We and our service providers use the
                            information for security purposes, to facilitate navigation, to display information more
                            effectively, and to personalize your experience while using the Application and to enhance
                            user engagement. We also use Cookies and Pixels to gather statistical information about use
                            of the Application to continually improve its design and functionality, to understand how it
                            is used, and to answer questions regarding the Application.
                        </p>
                    </li>
                </ol>
            </div>

            <div class="block">
                <strong>
                    <h5>Statement regarding the Categories of Personal Information being collected. </h5>
                </strong>
                <p>We collect “Personal Information” from the following categories:</p>
                <ul>
                    <li>
                        (A) Identifiers (ex. real name, alias, postal address, unique identifiers, online identifiers,
                        internet protocol (“IP”) address, email address, account name, social security number, driver’s
                        license number, passport number, or other similar identifiers.
                    </li>
                    <li>
                        (B) Information about your health, including your mental or physical health conditions or
                        diagnoses. More information about the health information we collect is available in our Consumer
                        Health Information Privacy Notice, available at www.visor.health/health-privacy.
                    </li>
                    <li>
                        (B) Characteristics of protected classifications under federal law, including racial or ethnic
                        origin.
                    </li>
                    <li>
                        (C) Commercial information, including records of personal property, products or services
                        purchased, obtained, or considered, or other purchasing or consuming histories or tendencies.
                    </li>
                    <li>
                        (D) Internet or other electronic network activity information, including, but not limited to,
                        browsing history, search history, and information regarding a consumer’s interaction with an
                        internet website, application or advertisement.
                    </li>
                    <li>(E) Geolocation data. </li>
                    <li>
                        (F) Inferences drawn from any of the information identified in this subdivision to create a
                        profile about a reflection of the consumer’s preferences, characteristics, psychological trends,
                        predispositions, behavior, attitudes, intelligence, abilities, and aptitudes.
                    </li>
                </ul>

            </div>

            <div class="block">
                <strong>
                    <h5>Your Personal Information Rights </h5>
                </strong>
                <p>
                    You may make certain requests regarding our use of your personal information by emailing us at
                    support&#64;osteocore.com. If you are a resident of the State of California, some of these requests may
                    be governed by CCPA. If you are not a California resident, or a response to any given request is not
                    required by CCPA or other applicable law, you agree that we are under no obligation to provide a
                    specific response to any such request, however, we agree to make commercially reasonable efforts to
                    respond to any request we receive, subject to local laws. For your protection, we may need to verify
                    your identity before acting on your request.
                </p>
                <ul>
                    <li>
                        You may request to review and obtain a copy of your personal information. We will provide a copy
                        or a summary of your information, usually within 30 days of your request. We may charge a
                        reasonable, cost-based fee.
                    </li>
                    <li>
                        You may request to amend your personal information. You can ask us to correct personal
                        information about you that you think is incorrect or incomplete. In your request, please make
                        clear what personal information you would like to have changed. We may say “no” to your request,
                        but we’ll tell you why in writing within 60 days.
                    </li>
                    <li>
                        You may request to restrict use or disclosure of Personal Information in certain circumstances.
                        Although we do not sell personal information about our users, you do have the right to
                        explicitly ask us not to sell your personal information to third-parties. This opt-out right
                        does not apply to personal information that we share with third-party service providers involved
                        in the operation of the Application.
                    </li>
                    <li>
                        You may ask for a list of those with whom we’ve shared personal information with. You can ask
                        for a list of who we’ve shared your personal information with, and why. We will usually deliver
                        the list within 30 days of your request.
                    </li>
                    <li>
                        You may request confidential communications. Within reason, we will act upon requests to contact
                        you in a specific way (for example, home or office phone) or to send mail to a different
                        address.
                    </li>
                    <li>
                        You may request a copy of this Privacy Notice. You can ask for a paper copy of this notice at
                        any time, even if you have agreed to receive the notice electronically. We will provide you with
                        a paper copy promptly.
                    </li>
                </ul>
            </div>
            <div class="block">
                <strong>
                    <h5>Age Requirements </h5>
                </strong>
                <p>
                    The Application is not designed or intended to appeal to minors and we do not knowingly collect User
                    Data from children under the age of 13. As a tool for providing the Application, users of the
                    Application may enter Application Information related to minors into the application where a parent
                    or guardian has consented to use of the Application with that individual. It is your responsibility
                    to make sure that consent from the parent or guardian is collected and documented.
                </p>
                <p>
                    If a parent or guardian becomes aware that his or her child has provided us with information without
                    their consent, he or she should contact us at support&#64;visor.health so we can promptly delete
                    such
                    information.
                </p>
            </div>

            <div class="block">
                <strong>
                    <h5>Security </h5>
                </strong>
                <p>
                    We are concerned about protecting the confidentiality of all information that we interact with in
                    providing the Application. We and our service providers make use of physical, electronic, and
                    procedural safeguards to protect the information that we process and maintain. Although we endeavor
                    to provide security for the information that we process and maintain based on the sensitivity of
                    that information, no security system can prevent all potential security breaches, and we do not
                    guarantee that a security breach of the Application will not occur.
                </p>
                <p>
                    In addition to the security safeguards we provide, we urge you to take precautionary measures in
                    maintaining the integrity of your data. Please be responsible for making sure that no one can see or
                    access your account or log-in/password information, or your mobile device.
                </p>
            </div>
            <div class="block">
                <strong>
                    <h5>Links to other sites and services </h5>
                </strong>
                <p>
                    The Application may contain links to other sites or services that are not operated by us. If you
                    click an outside link, you will be directed to that outside site or service. We strongly advise you
                    to review the privacy policy of every site you visit. We are not responsible for the privacy
                    practices or the content of any outside sites or services
                </p>

            </div>

            <div class="block">
                <strong>
                    <h5>Changes </h5>
                </strong>
                <p>
                    We reserve the right to modify this Privacy Policy at any time in our sole discretion by including
                    such alteration and/or modification in this Privacy Policy, along with a notice of the effective
                    date of such modified Privacy Policy. Any continued use by you of the Application after the posting
                    of such modified Privacy Policy shall be deemed to indicate your agreement to such modified Privacy
                    Policy. Accordingly, if at any time you do not agree to be subject to any modified Privacy Policy,
                    you may no longer use the Application.
                </p>

            </div>
        </div>
    </div>
</section>